import React from 'react'
import { Box, Input } from '@mui/material'

const DetailsAreaTaskCreator: React.FC<{
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}> = ({ value, onChange, disabled = false }) => {
  return (
    <Box
      sx={{
        borderRadius: '4px',
        px: '11px',
        border: '1px solid rgba(50, 59, 119, 0.10)',
      }}
    >
      <Input
        dir="rtl"
        multiline
        rows={6}
        value={value}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        fullWidth
        placeholder="כתיבת תיאור"
        disableUnderline
        sx={{
          borderRadius: '4px',
        }}
      />
    </Box>
  )
}

export default DetailsAreaTaskCreator
